import React, { Component } from 'react';
import logo from './logo.svg';
import './assets/style/general-style.css';

import LoginPage from './pages/login/login.page';
import HomeComponent from './components/home/home.component';

import ProjectListPage from './pages/project/list/project-list.page';
import ProjectDetailPage from './pages/project/detail/project-detail.page';

import AppController from './app.controller';

import {
  Router as Router,
  Route,
  Link,
  Switch,
  Redirect
} from 'react-router-dom';

import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
let appController = new AppController();

class App extends Component {
  constructor() {
    super();
    this.state = {
      user: appController.getUser(),
      tags: appController.getTags(),
      filterBookmarked: false
    }

   this._checkUserState();
  }

  componentDidUpdate() {
    this._checkUserState();
  }

  componentWillMount() {
    
    appController.on('updateUser', () => {
      this.setState({user: appController.getUser()});
    });

    appController.on('updateTags', () => {
      this.setState({tags: appController.getTags()});
    });
  }

  _checkUserState() {
    if(this.state.user !== null) {
      history.push('/home');
    }else {
      history.push('/');
    }
  }

  _filterBookmark(state) {
    this.setState({filterBookmarked: state});
    history.push('/home');
  }

  _login(result) {
    appController.setUser(result.data);
  }

  _handleLogout() {
    appController.logout();
  }

  render() {
    let appNavigation = '';

    if(this.state.user !== null) {
      appNavigation = <nav className="app-navigation">
                        <ul>
                          <li>
                            <button onClick={this._filterBookmark.bind(this, true)}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bookmark"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg>
                            </button>
                          </li>
                          <li>
                            <button onClick={this._filterBookmark.bind(this, false)}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                            </button>
                          </li>
                          <li>
                            <Link to="/projects">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="feather feather-folder"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
                            </Link>
                          </li>
                          <li style={{position: 'absolute', left: 0}}>
                            <button onClick={this._handleLogout.bind(this)}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="feather feather-log-out"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                            </button>
                          </li>
                        </ul>
                      </nav>;
    }
    return (
      <Router history={history}>
        <div>
          
          <main>
            <Switch>
              <Route path="/hello" render={() => { return      <h2>BUB</h2> }} />
              <Route path="/projects/:id" render={(props) => (<ProjectDetailPage history={history} user={this.state.user} tags={this.state.tags} />)} />
              <Route path="/projects" render={(props) => (<ProjectListPage user={this.state.user} tags={this.state.tags}/>)} />
              <Route path="/home" render={(props) => (<HomeComponent user={this.state.user} tags={this.state.tags} filterBookmarked={this.state.filterBookmarked}/>)} />
              <Route path="/" render={(props) => (<LoginPage login={appController.login.bind(appController)}/>)} />
            </Switch>
          </main>

          {appNavigation}

          
          
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// src/App.js